// @ts-nocheck
export { CITY_HOME_ROUTES, ROLE_HOME_ROUTES, SPECIALIZED_HOME_ROUTES } from '../shared/home-route-config.ts';

export const COMING_SOON_ROUTES = [
  {
    path: '/post-job',
    title: 'Employer Tools Coming Soon',
    description: 'Employer posting and pipeline tools are not open yet. Use the advertising page for current partnership options.',
    ctaLabel: 'View advertising options',
    ctaTo: '/ads'
  },
  {
    path: '/candidatures',
    title: 'Candidacies Hub Coming Soon',
    description: 'Application tracking is not live yet. For now, save jobs and manage alerts from your account.',
    ctaLabel: 'Open account',
    ctaTo: '/account'
  },
  {
    path: '/opportunities',
    title: 'Opportunities Feed Coming Soon',
    description: 'This discovery feed is not live yet. Browse companies, jobs, and events from the main navigation.',
    ctaLabel: 'Browse companies',
    ctaTo: '/companies'
  },
];

export const SALARY_DETAIL_PATHS = [
  '/developer-salaries',
  '/non-tech-salaries',
  '/highest-paying-ai-jobs',
  '/usa-vs-world-salaries'
];
